import styled from "styled-components";
import {FaTimes} from "react-icons/fa";
import {Link as LinkScroll} from "react-scroll";
import {Link as LinkRouter } from "react-router-dom";


export const SidbarContainer = styled.div`
position: fixed;
z-index: 999;
width: 100%;
height: 100%;
background: #0d0d0d;
display: grid;
align-itemns: center;
top: 0;
left: 0;
transition: 0.3 ease-in-out;
opacity: ${({isOpen}) => (isOpen ? "100%" : "0")};
top: ${({isOpen}) => (isOpen ? "0" : "-100%")}; 

`
export const Icon = styled.div`
position: absolute;
top: 1.2rem;
right: 1.5rem;
background: transparent;
font-size: 2rem;
cursor: pointer;
outlined: none;

`
export const CloseIcon = styled(FaTimes)`
color :#fff;
`

export const SidebarWrapper = styled.div`
color: #fff;
`
export const SidebarLink = styled(LinkScroll)`
display: flex;
align-items: center;
justify-content: center;
font-size: 1.5rem;
text-decoration: none;
list-style: none;
transition: 0.2s ease-in-out;
text-decoration: none;
color: #fff;
cursor: pointer;

&:hover{
    color: #64954b;
    transition: 0.2s ease-in-out;
}
`
export const SidebarMenu = styled.ul`
display: grid;
grid-template-columns: 1fr;
grid-template-rows: repeat(6, 95px);
text-align: center;

@media screen and (max-width: 480px) {
    grid-template-rows: repeat(6, 60px);
}
`

export const SideBtnWrap = styled.div`
display: flex;
justify-content: center;

`

export const SidebarRoute = styled(LinkRouter)`
border-radius: 50px;
background: #64954b;
white-space: nowrap;
padding: 16px 64px;
color: #010606;
font-size: 16px;
outlined: none;
border: none;
cursor:pointer;
transition: all 0.2s ease-in-out;
text-decoration: none;

&:hover{
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #64954b;
}
`